import { render } from "./ModelAssessment.vue?vue&type=template&id=495eca56&scoped=true"
import script from "./ModelAssessment.vue?vue&type=script&lang=js"
export * from "./ModelAssessment.vue?vue&type=script&lang=js"

import "./ModelAssessment.vue?vue&type=style&index=0&id=495eca56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495eca56"]])

export default __exports__